import React from 'react'
import { Paper, CardActions, Box, Divider, Typography } from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'
import SaveIcon from '@mui/icons-material/Save'

interface ICardWithActionButtonProps {
  headerTitle?: string
  buttonText?: string
  loading: boolean
  handleClick?: () => void
  children: React.ReactNode
  showIcon?: boolean
  buttonSize?: 'small' | 'medium' | 'large'
  otherActionComponents?: React.ReactNode
  disabled?: boolean
}

/**
 * CardWithHeaderAndActionButton
 *
 * @param __namedParameters ICardWithActionButtonProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const CardWithHeaderAndActionButton: React.FC<ICardWithActionButtonProps> = ({
  headerTitle = '',
  buttonText = 'SAVE',
  loading = false,
  handleClick,
  children,
  showIcon = true,
  buttonSize = 'medium',
  otherActionComponents,
  disabled = false
}): JSX.Element => {
  return (
    <Paper>
      <Typography
        sx={{ color: 'text.primary', fontSize: 20, fontWeight: 'medium' }}
        variant="h2"
        padding={2}
      >
        {headerTitle}
      </Typography>
      <Divider />
      <Box padding={3}>{children}</Box>
      <Divider />
      <CardActions sx={{ justifyContent: 'flex-end', padding: '16px' }}>
        {otherActionComponents}
        <LoadingButton
          color="primary"
          onClick={handleClick}
          type="submit"
          loading={loading}
          loadingPosition="start"
          startIcon={showIcon && <SaveIcon />}
          variant="contained"
          size={buttonSize}
          sx={{ fontSize: '15px' }}
          disabled={disabled}
        >
          {buttonText}
        </LoadingButton>
      </CardActions>
    </Paper>
  )
}
